







import Vue from 'vue';
import LocationBasedMixin from '@/Shared/LocationBasedMixin';
import mixins from 'vue-typed-mixins';
import VatsAPI from '@/Shared/VatsAPI';
import { EscalationVariables } from '../EscalationVariables';
import { EscalationType } from '../EscalationType';
import { Escalation } from './Escalation';
import { getValidationErrors } from '@/Shared/ValidationErrorDirective';
import { TranslateResult } from 'vue-i18n';
import BuildEntityComponent from '@/Shared/CommonEntityMixins/EntityComponentMixin';
import EscalationList from './EscalationList.vue';
import RadioToggle from '@/Shared/RadioToggle.vue';

const component = mixins(LocationBasedMixin, BuildEntityComponent<EscalationVariables>()).extend({
    name: 'escalationVariables',
    components: {
        EscalationList,
        RadioToggle
    },
    data() {
        return {
            i18nPrefix: 'admin.programVariables.escalationManagement.citationEscalations',
            EscalationType,
            escalationTypeDisplay: Object.keys(EscalationType)
                .filter(k => typeof EscalationType[k as any] === 'string'),
        };
    },
    computed: {
        entityUrls() {
            return `${this.location}/Citations/EscalationVariables`;
        },
    },
});

export default component;
